import { AlphaYIcon } from './AlphaYIcon';

/**
 * author: GreenTurtwig
 * id CD6A13CC-DA14-42AD-A4A0-2A99EA3E5E3D
 * name alpha-y
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-y.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterYIcon = AlphaYIcon;
export default LetterYIcon